import s from "./Header.module.scss";


const Header = () => {

    return (
        <header>
            <nav>
                <a className={s.logo} href="https://www.avh.asso.fr/" target='_blank'>
                    <img src="/assets/logo_avh.png" alt="Valentin Haüy Avec les aveugles et les malvoyants. Agir pour l'autonomie." />
                </a>
            </nav>
        </header>
    )
}

export default Header;